import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { DocumentService } from '../../../shared/web-api/document.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-image-map-viewer',
    templateUrl: './image-map-viewer.component.html',
    styleUrls: ['./image-map-viewer.component.css']
})
export class ImageMapViewerComponent implements OnInit {

    @Input() model: app.models.WorkflowNodeAnchorModel;
    @Input() width?: number;
    @Input() height?: number;
    @Input() imagestyle: string;
    @Input() currentNodeCode?: number;
    @Output() selectnode: EventEmitter<number> = new EventEmitter<number>();
    style = {};
    currentAreaCoords: number[] = null;
    calculatedAreas: app.models.WorkflowNodeAnchorAreaModel[];
    blinkActive: boolean;

    constructor(private documentService: DocumentService, private sanitizer: DomSanitizer) { }

    ngOnInit() {

        this.setCalculatedImageSize(this.width, this.height);
        if (this.model.areas) {
            this.calculatedAreas = this.model.areas.map(x => <app.models.WorkflowNodeAnchorAreaModel>{
                coordinates: x.coordinates,
                displayName: x.displayName,
                targetWorkflowNodeCode: x.targetWorkflowNodeCode
            });
        }

        this.setCurrentAreaCoords();

        this.blink(0);
    }

    get imageUrl(): string {
        if (this.model.documentId)
            return this.documentService.Urls.readImage(this.model.documentId);
        else
            return "";
    }

    gotoNode(code: number) {
        this.selectnode.emit(code);
    }

    imageLoad(event: UIEvent) {
        if (!this.width || !this.height) {
            return;
        }

        let imageElement = <HTMLImageElement>event.srcElement;
        let aspectRatio = imageElement.naturalWidth / imageElement.naturalHeight;
        let height = this.width / aspectRatio;
        let width = this.width;
        if (height > this.height) {
            width = this.height * aspectRatio;
            height = this.height;
        }

        let widthRatio = width / imageElement.naturalWidth;
        let heightRatio = height / imageElement.naturalHeight;

        for (let area of this.calculatedAreas) {
            let coords = area.coordinates.split(",");
            area.coordinates = [
                +coords[0] * widthRatio,
                +coords[1] * heightRatio,
                +coords[2] * widthRatio,
                +coords[3] * heightRatio].join();
        }

        this.setCalculatedImageSize(width, height);
        this.setCurrentAreaCoords();
    };

    private setCurrentAreaCoords() {
        if (this.calculatedAreas && this.currentNodeCode) {
            let currentArea = this.calculatedAreas.find(x => x.targetWorkflowNodeCode == this.currentNodeCode);
            if (currentArea) {
                let coords = currentArea.coordinates.split(",");
                this.currentAreaCoords = [+coords[0], +coords[1], +coords[2], +coords[3]];

            }
        }
    }

    private setCalculatedImageSize(width: number, height: number) {
        if (this.width || this.height) {
            // Theme overwrites image width so we must specify it with important
            this.style = this.sanitizer.bypassSecurityTrustStyle(`${this.imagestyle} width: ${width}px !important; height: ${height}px !important`);
        }
        else {
            this.style = this.sanitizer.bypassSecurityTrustStyle(`${this.imagestyle}`);
        }
    }


    public blink(iteration: number) {

        if (iteration >= 16)
            return;

        setTimeout(() => {
            this.blinkActive = !this.blinkActive;
            this.blink(iteration + 1)

        }, 800);
    }

}



// WEBPACK FOOTER //
// ./src/app/workflows/content-renderer/image-map-viewer/image-map-viewer.component.ts